import React from 'react';
import { inject } from 'mobx-react';
import Link from 'core/components/Link';

const DeviceConfigLink = ({ $app, deviceName, revision, children, ...rest }) => {
  if ($app.isSubtenant) {
    return children;
  }

  return (
    <Link to={`/v4/infrastructure/devices/${deviceName}/configs/${revision}`} {...rest}>
      {children || revision}
    </Link>
  );
};

export default inject('$app')(DeviceConfigLink);
